import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromEvent, Subject, merge } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { QueryCompanies } from '../../models/query-companies';
import { QueryCompaniesAction } from '../../actions/query-companies.action';

@Component({
  selector: 'app-search-companies',
  templateUrl: './search-companies.component.html',
  styleUrls: ['./search-companies.component.scss']
})
export class SearchCompaniesComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedFilter = 'all';

  @ViewChild('searchInput', { static: false }) companyNameInput!: ElementRef;
  @ViewChild('searchCnpj', { static: false }) cnpjInput!: ElementRef;

  profile: string;
  destroy$ = new Subject<any>();
  pageIndex: number = 0;
  pageSize: number = 10;

  constructor(private readonly queryCompaniesState: Store<QueryCompanies>) {}

  ngOnInit(): void {
    this.sendNewCompanyQuery();
  }

  ngAfterViewInit() {
    this.setupInputFilters();
  }

  profileFilter(profile: any) {
    this.profile = profile.value;
    this.sendNewCompanyQuery();
  }

  setupInputFilters() {
    if (!this.companyNameInput?.nativeElement || !this.cnpjInput?.nativeElement) {
      console.error('One or both input elements are NOT available in the view to set up filters!');
      return;
    }

    const companyNameChanges$ = fromEvent(this.companyNameInput.nativeElement, 'keyup');
    const cnpjChanges$ = fromEvent(this.cnpjInput.nativeElement, 'keyup');

    merge(companyNameChanges$, cnpjChanges$)
      .pipe(
        debounceTime(800),
        switchMap(async () => {
          return this.sendNewCompanyQuery();
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  async sendNewCompanyQuery() {
    let query: QueryCompanies = {
      companyName: this.companyNameInput?.nativeElement?.value || null,
      cnpj: this.cnpjInput?.nativeElement?.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase(),
      profileCode: this.profile || null,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    };
    this.queryCompaniesState.dispatch(QueryCompaniesAction(query));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.queryCompaniesState.dispatch(QueryCompaniesAction(undefined));
  }
}
